import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { rootReducer } from './rootReducer';
export var composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
export var configureStore = function (preloadedState) {
    var preloadedStateReducer = preloadedState;
    var store = createStore(rootReducer, preloadedStateReducer, composeEnhancers(applyMiddleware(thunk)));
    if (module.hot) {
        module.hot.accept('./rootReducer', function () {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            var nextRootReducer = require('./rootReducer').default;
            store.replaceReducer(nextRootReducer);
        });
    }
    return store;
};
